import { render } from "./ui-label-input.vue?vue&type=template&id=13d3d816&ts=true"
import script from "./ui-label-input.vue?vue&type=script&lang=ts"
export * from "./ui-label-input.vue?vue&type=script&lang=ts"

import "./ui-label-input.vue?vue&type=style&index=0&id=13d3d816&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__